document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('categoryGrid');
    if (!container) return;

    const allItems = Array.from(container.children);
    const count = allItems.length;

    if (window.innerWidth >= 1024 && count % 2 === 1 && count >= 3) {
        container.innerHTML = '';
        const normalCount = count - 3;

        for (let i = 0; i < normalCount; i += 2) {
            const row = document.createElement('div');
            row.className = 'grid gap-7.5 lg:grid-cols-2';
            row.appendChild(allItems[i]);
            if (allItems[i + 1]) row.appendChild(allItems[i + 1]);
            container.appendChild(row);
        }

        const lastRow = document.createElement('div');
        lastRow.className = 'grid gap-7.5 lg:grid-cols-3';
        for (let i = normalCount; i < count; i++) {
            lastRow.appendChild(allItems[i]);
        }
        container.appendChild(lastRow);

    } else {
        container.classList.add('grid', 'gap-7.5', 'lg:grid-cols-2');
    }
});
